// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"9d43d834","173":"f4a75a52","313":"20da6852","353":"1026f054","384":"82c16cc4","415":"54853dfc","450":"c6ccccf8","541":"05c84d7d","587":"51e8c960","754":"c92ad012"}[chunkId] + ".chunk.js";
};